import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { BooleanValue } from 'react-values';
import { withStyles } from '@material-ui/core/styles';
import { Dialog as MUIDialog } from '@material-ui/core';

import { RButton } from '../Button';

const Dialog = withStyles(theme => ({
  paper: {
    background: 'none',
  },
  paperWidthSm: {
    width: '100%',
    maxWidth: 'none',
    margin: '16px 0 !important',

    '@media(min-width: 695px)': {
      width: '90%',
      margin: '48px auto !important',
    },
    '@media(min-width: 1280px)': {
      maxWidth: '1280px',
      margin: '48px auto !important',
    },
  },
}))(MUIDialog);
export default class Modal extends Component {
  static propTypes = {
    open: PropTypes.bool,
    title: PropTypes.node,
    content: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
    // button: PropTypes.node,
  };

  static defaultProps = {
    button: <RButton variant="action" title="click me" />,
  };

  render() {
    const { title, content, button, borderless, ...restProps } = this.props;
    return (
      <BooleanValue>
        {({ value: opened, toggle }) => (
          <Fragment>
            {React.cloneElement(button, { onClick: toggle })}
            <Dialog
              open={opened}
              scroll="body"
              onClose={toggle}
              PaperProps={{ elevation: 0 }}
              {...restProps}
            >
              {typeof content === 'function' ? content(toggle) : content}
            </Dialog>
          </Fragment>
        )}
      </BooleanValue>
    );
  }
}
